import { Component, EventEmitter, Output, Input, SimpleChanges } from '@angular/core';
import { TopHeaderComponent } from "./top-header/top-header.component";
import { MainHeaderComponent } from "./main-header/main-header.component";
import { MobileSideNavComponent } from "./mobile-side-nav/mobile-side-nav.component";
import { buildUrl, isEmptyObject } from '@shared/utilities/common.utils';
import { SITE_LINKS } from '@shared/constants/site-links.constants';
import { UserStore } from '@shared/stores/user/user.store';
import { CustomerStore } from '@shared/stores/customer/customer.store';

@Component({
    selector: 'avenir-header',
    imports: [
        TopHeaderComponent,
        MainHeaderComponent,
        MobileSideNavComponent
    ],
    templateUrl: './header.component.html',
    styleUrl: './header.component.scss'
})
export class HeaderComponent {
  @Input() isLoggedIn: boolean = false;
  @Input() customerId: string = '';
  phoneNumber: string = '1-888-710-6507';
  loggedInUser!: any;
  loggedInMenuItems: MenuItem[] = [];
  topRightMenuItems: MenuItem[] = [
      // {
      //   label: $localize`:@@contactUs:Contact Us`,
      //   url: '',
      //   inMobile: true,
      //   inDesktop: true,
      //   btn: false,
      //   selected: false
      // },{
      //   label: $localize`:@@locations:Locations`,
      //   url: '',
      //   inMobile: true,
      //   inDesktop: true,
      //   btn: false,
      //   selected: false
      // },{
      //   label: $localize`:@@support:Support`,
      //   url: '',
      //   inMobile: true,
      //   inDesktop: true,
      //   btn: false,
      //   selected: false
      // }
    ];
  showSideNavStatus = false;
  @Output() sideMenuState = new EventEmitter<boolean>();

  constructor(
    private userStore: UserStore,
    private customerStore: CustomerStore
  ){}

  ngOnInit(){
    if (!isEmptyObject(this.userStore.getUser())) {
      this.isLoggedIn = true;
      this.initializeMenuItems();
    } else {
      this.isLoggedIn = false;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['customerId']) {
      if (this.isLoggedIn) {
        this.loggedInUser = this.userStore.getUser();
        if (!this.customerId) {
          this.customerStore.selectCustomer(this.loggedInUser.customers[0].customerId);
        }
        this.initializeMenuItems();
      }
    }
  }

  initializeMenuItems() {
    this.loggedInMenuItems =  [{
      label: $localize`:@@myLocations:My Locations`,
      url: buildUrl(SITE_LINKS.TANK.BASE, this.customerId),
      inMobile: true,
      inDesktop: true,
      btn: false,
      selected: false
    },{
      label: $localize`:@@deliveries:Deliveries`,
      url:  buildUrl(SITE_LINKS.DELIVERY.BASE, this.customerId),
      inMobile: true,
      inDesktop: true,
      btn: false,
      selected: false
    },
    {
      label: $localize`:@@serviceRequests:Service Requests`,
      url: buildUrl(SITE_LINKS.SERVICE.BASE, this.customerId), 
      inMobile: true,
      inDesktop: true,
      btn: false,
      selected: false
    },
    {
      label: $localize`:@@billingAndPayments:Billing & Payments`,
      // url: buildUrl(SITE_LINKS.BILLING.BILLING_HISTORY, this.customerId),
      url: buildUrl(SITE_LINKS.BILLING.BASE, this.customerId),
      inMobile: true,
      inDesktop: true,
      btn: false,
      selected: false
    },{
      label: $localize`:@@requestNewService:Request New Service`,
      url: buildUrl(SITE_LINKS.SERVICE.REQUEST, this.customerId),
      inMobile: false,
      inDesktop: false,
      btn: true,
      selected: false
    }];
  }

  showSideNav(value: boolean){
    this.showSideNavStatus = value;
    this.sideMenuState.emit(this.showSideNavStatus);
  }

  hideSideNav(value: boolean){    
    this.showSideNavStatus = value;
    this.sideMenuState.emit(this.showSideNavStatus);
  }
}


export interface MenuItem{
  label: string,
  url: string,
  btn: boolean,
  inMobile: boolean,
  inDesktop: boolean,
  selected: boolean,
  class?: string
}
